import React from 'react';
import { css, keyframes } from '@emotion/css';
import { useTransition, animated } from '@react-spring/web';
import { useLoading } from '../../hooks/use-loading';
import { LogoSymbol } from '../../../../shared/ui/logo-symbol/logo-symbol';
import { LogoType } from '../../../../shared/ui/logo-type/logo-type';

const anchorRotation = keyframes({
  '0%': {
    transform: 'rotate(360deg)',
  },
  '100%': {
    transform: 'rotate(0deg)',
  },
});

const loadingWrapper = css({
  position: 'fixed',
  width: '100%',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'var(--primary-color)',
  top: 0,
  left: 0,
  zIndex: 9999,
  
  '@media (max-width: 799px)': {
    height: '100dvh', // Dynamic viewport height for mobile
  },
});

const loading = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 'var(--spacing-md)',
});

const anchorSimbolo = css({
  height: '100px',
  width: '100px',
  animation: `${anchorRotation} 1s ease-in-out infinite`,
  
  '& img': {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
  },
});

const anchorTipo = css({
  height: '50px',
  
  '& img': {
    height: '100%',
    objectFit: 'contain',
  },
});

export const Loading: React.FC = () => {
  const { isLoading } = useLoading();

  const transitions = useTransition(isLoading, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 180 },
  });

  return transitions(
    (styles, item) =>
      item && (
        <animated.div style={styles} className={loadingWrapper}>
          <div className={loading}>
            <div className={anchorSimbolo}>
              <LogoSymbol />
            </div>
            <div className={anchorTipo}>
              <LogoType />
            </div>
          </div>
        </animated.div>
      )
  );
};
